import * as React from 'react';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import UserSettingsLegal from '~/apps/shared/containers/settings/SettingsLegal';


export default function() {
  return (
    <CurrentOrgInjector
      component={UserSettingsLegal}
    />
  );
};
